import { Component } from '@angular/core';
import { HeaderComponent } from '../shared/header/header.component';
import { HeroComponent } from './hero/hero.component';
import { NewarrivedComponent } from './newarrived/newarrived.component';
import { ServicesandproductsComponent } from './servicesandproducts/servicesandproducts.component';
import { ClientsComponent } from './clients/clients.component';
import { FooterComponent } from '../shared/footer/footer.component';
import { TranslateService } from '@ngx-translate/core';
import { StyleDirectionService } from '../services/style-direction.service';
import { CategoriesComponent } from './categories/categories.component';
// ComponentsComponent
@Component({
  selector: 'app-components',
  standalone: true,
  imports: [
    HeaderComponent,
    HeroComponent,
    NewarrivedComponent,
    ServicesandproductsComponent,
    ClientsComponent,
    CategoriesComponent,
    FooterComponent,
  ],
  templateUrl: './components.component.html',
  // styleUrl: './components.component.css',
})
export class ComponentsComponent {
  Direction: string = 'ltr';

  constructor(
    private translate: TranslateService,
    private styleDirectionService: StyleDirectionService
  ) {
    // Get the stored locale from localStorage or default to Arabic
    const storedLang = localStorage.getItem('locale') || 'ar';
    this.translate.setDefaultLang(storedLang); // Set default language
    this.translate.use(storedLang); // Use the stored language

    // Update the direction and apply styles based on language
    this.setDirectionAndStyles(storedLang);
  }

  setDirectionAndStyles(storedLang: string) {
    if (storedLang === 'ar') {
      this.Direction = 'rtl';
      this.styleDirectionService.fillData(true); // Load RTL Bootstrap
    } else {
      this.Direction = 'ltr';
      this.styleDirectionService.fillData(false); // Load LTR Bootstrap
    }
  }
  
}
